const baseUrl =
  process.env.REACT_APP_BASE_URL || 'https://service2.funifier.com/v3';

export interface ImageObject {
  _id?: string;
  url?: string;
}

/**
 * Converte um item de imagem para URL exibível
 * Suporta:
 * - File: cria ObjectURL
 * - string: retorna como está (URL legada)
 * - { _id: string }: constrói URL v3/upload/{id}/file com token
 * - { url: string }: retorna a URL (formato legado)
 *
 * @param item - O item de imagem (File, string, ou objeto com _id/url)
 * @param accessToken - Token de acesso para autenticação (opcional)
 */
export function getImageUrl(
  item: File | string | ImageObject | null | undefined,
  accessToken?: string,
): string {
  if (!item) return '';

  // Se for um File, cria ObjectURL
  if (item instanceof File) {
    return URL.createObjectURL(item);
  }

  // Se for string, retorna como está (URL legada ou blob URL)
  if (typeof item === 'string') {
    return item;
  }

  // Se for objeto com _id, constrói a URL com token
  if (typeof item === 'object' && '_id' in item && item._id) {
    const url = `${baseUrl}/upload/${item._id}/file`;
    return accessToken ? `${url}?access_token=${accessToken}` : url;
  }

  // Se for objeto com url (formato legado)
  if (typeof item === 'object' && 'url' in item && item.url) {
    return item.url;
  }

  return '';
}

/**
 * Verifica se um item de imagem tem valor válido
 * Suporta novo formato { _id: string } e formato legado string/url
 */
export function hasImageValue(
  item: File | string | ImageObject | null | undefined,
): boolean {
  if (!item) return false;

  if (item instanceof File) return true;
  if (typeof item === 'string') return item.length > 0;
  if (typeof item === 'object') {
    return !!item._id || !!item.url;
  }

  return false;
}
